(() => {
  const gallerySelector = 'product-info[id^="MainProduct"] [id^="GalleryViewer-"]';

  const initGallery = (gallery) => {
    if (!gallery || gallery.dataset.mocloomAligned === 'true') return;

    const slider = gallery.querySelector('[id^="Slider-Gallery-"]');
    const prevButton = gallery.querySelector('.slider-button--prev');
    const nextButton = gallery.querySelector('.slider-button--next');
    const thumbnails = Array.from(gallery.querySelectorAll('[data-product-gallery-thumb]'));

    if (!slider || !prevButton || !nextButton) return;

    gallery.dataset.mocloomAligned = 'true';

    const getSlides = () =>
      Array.from(slider.querySelectorAll('[id^="Slide-"]')).filter(
        (slide) => slide.clientWidth > 0
      );

    const updateTail = () => {
      slider.style.setProperty(
        '--moc-product-gallery-tail',
        `${slider.clientWidth}px`
      );
    };

    const nearestIndex = () => {
      const slides = getSlides();
      if (!slides.length) return 0;
      return slides.reduce((closest, slide, index) => {
        const currentDistance = Math.abs(slider.scrollLeft - slide.offsetLeft);
        const closestDistance = Math.abs(
          slider.scrollLeft - slides[closest].offsetLeft
        );
        return currentDistance < closestDistance ? index : closest;
      }, 0);
    };

    const slideIndexFromThumb = (thumb) => {
      const targetId = thumb && thumb.dataset ? thumb.dataset.target : null;
      const slides = getSlides();
      if (!targetId || !slides.length) return -1;
      return slides.findIndex((slide) => slide.id === targetId);
    };

    const thumbIndexFromSlide = (slide) => {
      if (!slide || !slide.id) return -1;
      return thumbnails.findIndex((thumb) => thumb.dataset.target === slide.id);
    };

    const alignTo = (index) => {
      const slides = getSlides();
      if (!slides.length) return;
      const targetIndex = Math.max(0, Math.min(index, slides.length - 1));
      slider.scrollTo({
        left: slides[targetIndex].offsetLeft,
        behavior: 'smooth',
      });
      updateActiveThumb(thumbIndexFromSlide(slides[targetIndex]));
    };

    const updateActiveThumb = (forcedIndex = thumbIndexFromSlide(getSlides()[nearestIndex()])) => {
      thumbnails.forEach((thumb, index) => {
        const isActive = index === forcedIndex;
        thumb.classList.toggle('is-active', isActive);
        thumb.setAttribute('aria-selected', isActive ? 'true' : 'false');
      });
    };

    const onButtonClick = (event) => {
      event.preventDefault();
      event.stopImmediatePropagation();
      const direction = event.currentTarget.name === 'next' ? 1 : -1;
      alignTo(nearestIndex() + direction);
    };

    // Thumbnail click → scroll to corresponding slide
    thumbnails.forEach((thumb) => {
      thumb.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopImmediatePropagation();
        const targetIndex = slideIndexFromThumb(thumb);
        if (targetIndex >= 0) alignTo(targetIndex);
      });
    });

    let scrollFrame = null;
    const scheduleThumbUpdate = () => {
      if (scrollFrame) return;
      scrollFrame = window.requestAnimationFrame(() => {
        updateActiveThumb();
        scrollFrame = null;
      });
    };

    updateTail();
    updateActiveThumb();
    prevButton.addEventListener('click', onButtonClick, { capture: true });
    nextButton.addEventListener('click', onButtonClick, { capture: true });
    slider.addEventListener('scroll', scheduleThumbUpdate);
    window.addEventListener('resize', updateTail);
  };

  const initAll = () => {
    document.querySelectorAll(gallerySelector).forEach(initGallery);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', initAll);
})();
